/*
 * @Author       : LiYang
 * @Date         : 2021-08-17 19:35:09
 * @LastEditTime : 2021-12-23 21:07:44
 * @LastEditors  : Please set LastEditors
 * @Description  :
 */
export default function classNames () {
  var classes = []
  var hasOwn = {}.hasOwnProperty

  for (var i = 0; i < arguments.length; i++) {
    var arg = arguments[i]
    if (!arg) continue

    var argType = typeof arg

    if (argType === 'string' || argType === 'number') {
      classes.push(arg)
    } else if (Array.isArray(arg)) {
      if (arg.length) {
        var inner = classNames.apply(null, arg)
        if (inner) {
          classes = classes.concat(inner)
        }
      }
    } else if (argType === 'object') {
      if (arg.toString === Object.prototype.toString) {
        for (var key in arg) {
          if (hasOwn.call(arg, key) && arg[key]) {
            classes.push(key)
          }
        }
      } else {
        classes.push(arg.toString())
      }
    }
  }

  return classes
}
